export default class Textline{
	constructor(lineset){
		//const lineset = document.querySelectorAll(".index__introduction__body .textline");
		const totalLength = Array.from(lineset).reduce((acc, line) => acc + line.offsetHeight, 0);
		const segmentLength = Array.from(lineset).map((line, index, lineset) => {
			return {
				index: index,
				dom: line.querySelector(".textline__pseudo"),
				unit: line.offsetHeight,
				start: Array.from(lineset).slice(0, index).reduce((acc, line) => acc + line.offsetHeight, 0),
				end: Array.from(lineset).slice(0, index+1).reduce((acc, line) => acc + line.offsetHeight, 0)
			};
		});

		const textProgress = (progress)=>{
			if(totalLength <= 0) return;
			const position = totalLength*progress;
			const current =  segmentLength.find((elm) => elm.end>=position);
			const unitProgress = ((position-current.start)/current.unit)*100;

			for(let i=0; i<current.index; i++){
				segmentLength[i].dom.style.clipPath = "inset(0% 0% 0% 0%)";
			}
			for(let i=current.index; i<lineset.length; i++){
				segmentLength[i].dom.style.clipPath = "inset(0% 0% 100% 0%)";
			}
			current.dom.style.clipPath = "inset(0% 0% "+(100-unitProgress)+"% 0%)";
		}

		this.textProgress = textProgress;
	}
}